import Anchor from '@maxpreps/shared/corecomponents/Anchor/Anchor';
import { useIsMobile } from '@maxpreps/shared/hooks/useIsScreenSize';
import THEME from '@maxpreps/shared/styles/colors';
import Font from '@maxpreps/shared/styles/font';
import StyledText from '@maxpreps/shared/ui/Text/StyledText';
import styled from 'styled-components';

const StyledBadge = styled.span`
  color: ${THEME.text.tertiary};
  margin: 0 4px;
  white-space: pre-wrap;
  &::before {
    content: '(';
  }
  &::after {
    content: ')';
  }
`;

const StyledTeamMainCell = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`;

interface ITeamMainCellProps {
  mainText: string;
  mainOnClick?: Function;
  mainHref?: string;
  mainAs?: string;
  mainColor?: string;
  subText?: any;
  badges?: string[];
}

const TeamMainCell: React.FC<ITeamMainCellProps> = ({
  mainText,
  mainOnClick,
  mainHref,
  mainAs,
  mainColor,
  subText,
  badges
}) => {
  const isMobile = useIsMobile();

  const mainProps: any = {
    onClick: mainOnClick,
    $whiteSpace: 'pre-wrap',
    $color: mainColor
  };

  let MainComponent: any = StyledText;
  if (mainAs) mainProps.as = mainAs;
  if (mainHref) {
    MainComponent = Anchor;
    mainProps.href = mainHref;
  }

  return (
    <StyledTeamMainCell>
      <StyledText
        className={isMobile ? Font.f12_bold_tall : Font.f16_bold_tall}
      >
        <MainComponent {...mainProps}>{mainText}</MainComponent>
        {(badges?.length ?? 0) > 0 &&
          badges?.map(b => (
            <StyledBadge
              key={b}
              className={isMobile ? Font.f12_tall : Font.f14_tall}
            >
              {b}
            </StyledBadge>
          ))}
      </StyledText>
      {subText && (
        <StyledText
          className={isMobile ? Font.f12_tall : Font.f14_tall}
          $color={THEME.text.tertiary}
          as="div"
        >
          {subText}
        </StyledText>
      )}
    </StyledTeamMainCell>
  );
};

export default TeamMainCell;
